export const GET_JOB_BRIEFINGS_REQUEST = "GET_JOB_BRIEFINGS_REQUEST";
export const GET_JOB_BRIEFINGS_SUCCESS = "GET_JOB_BRIEFINGS_SUCCESS";
export const GET_JOB_BRIEFINGS_FAILURE = "GET_JOB_BRIEFINGS_FAILURE";

export const SET_JOB_BRIEFINGS_META = "SET_JOB_BRIEFINGS_META";
export const RESET_JOB_BRIEFINGS = "RESET_JOB_BRIEFINGS";
